import { useFormikContext } from 'formik'
import { useEffect } from 'react'

/**
 * Sets a Formik field value programmatically on mount, so the form is
 * submittable with a pre-filled value. Used to pre-populate fields like
 * comments when navigating from hints or report actions.
 */
export const SetInitialValue = ({ name, value }) => {
  const { setFieldValue } = useFormikContext()
  useEffect(() => {
    if (value != null) {
      setFieldValue(name, value, true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return null
}
